<template>
  <div>

    <data-tables
        class="first-checkbox"
        :tableClass="tableClass"
        :columns="getColumns"
        :rows="processedDownTimes"
        :drawTrigger="drawTick"
        tableID="job-downtimes-dt"
        routerLinkClass="dt-router-link"
        :tableInitOptions="tableInitOptions"
        :customFilters="customFilters"
    />

  </div>
</template>

<script>

import {mapGetters} from 'vuex';
import {en} from 'vuejs-datepicker/dist/locale';
//mixin
import timeCalc from '../../mixins/timeCalc';
import {dataTables} from '../../mixins/dataTables';
// @vuese
// @group StartStop
// This component shows the current and historical productionRuns of currently showing job

export default {
  name: 'JobDownTimes',
  props: {
    //@vuese
    // Passed in job to get the productionRuns from
    job: {
      required: true,
      type: Object,
      default: null
    }
  },
  data() {
    return {
      en: en,
      loadingDownTimes: true,
      drawTick: 0,
      jobId: null,
      channelOpen: false,
      filterOpen: true,
      filterOpenClass: 'm-hide-lg',
      searchUid: '',
      searchWorkflow: '',
      picker: {
        startDate: new Date(),
        endDate: new Date()
      },
      filterRunning: false,
      customFilters: [
        // {
        //   filter: 'dateRangeFilter',
        //   keyToFilter: 'downTimeIndicator',
        //   options: {
        //     range: {
        //       min: null,
        //       max: null
        //     }
        //   }
        // },
        {
          filter: 'arrayContains',
          keyToFilter: 'workflowId',
          options: {
            values: []
          }
        }


      ]
    };
  },

  mixins: [dataTables, timeCalc],
  methods: {},
  computed: {
    processedDownTimes() {
      let showActiveOnly = this.filterRunning;
      return _.filter(this.getDownTimesForJob(this.jobId), dt => {
        if (showActiveOnly && dt.downTimeEnded) return false;
        return !!dt;
      }).map(dt => {
        if (dt.downTimeEnded) {
          const ended = dt.downTimeEnded && dt.downTimeEnded.toDate ? dt.downTimeEnded.toDate() : dt.downTimeEnded;
          const started = dt.downTimeIndicator && dt.downTimeIndicator.toDate ? dt.downTimeIndicator.toDate() : dt.downTimeIndicator;
          let diff = moment(ended).diff(moment(started));
          let converted = this.convertMs(diff);
          return Object.assign({}, dt, {
            timeSpentRunningSort: diff,
            timeSpentRunning: `${converted.hrs}:${converted.min}:${converted.sec}`
          });
        }
        // Snapshot active downtimes so DataTable's deep watcher doesn't
        // fire on every Firestore sync of the reactive Vuex state object
        return Object.assign({}, dt);
      });
    },
    ...mapGetters('company', [
      'getConfig'
    ]),
    ...mapGetters('downTimes', [
      'getDownTimesForJob',
      'getFormattedDownTimeIndicator',
      'getDownTimeIcon'
    ]),
    ...mapGetters('workflows', [
      'getWorkflows',
      'getWorkflowName',
      'getWorkflowsIdName',
      'getWorkflowMultiOrderlinePossible',
      'getWorkflowMultiOrderPossible',
      'getWorkflowMultiJobPossible'
    ]),
    ...mapGetters('users', [
      'getSelectedWorkflow',
      'getMe',
      'getClaims',
      'getRunningJob',
      'getOrderlineWorkflowProduct',
      'getSelectedWorkflowLength'
    ]),
    // @vuese
    // Sets up the columns for datatables package from https://git.motivate.nl/js-awesome/motivate-framework-components/blob/v2/src/components/DataTable.vue
    getColumns() {
      let self = this;
      let statusAndButtonColumns = [
        {
          data: {
            _: null,
            sort: null
          },
          name: this.$t('productivity.result'),
          searchable: false,
          className: 'alignCenter',
          orderable: true,
          width: '1%',
          visible: true,
          render(data, type) {
            if (type == 'sort') {
              return data.downTimeEnded ? data.downTimeEnded : null;
            }
            return self.getDownTimeIcon(data.id);
          }
        },
        {
          data: null,
          name: self.$t('downTimes.table.workFlow'),
          responsivePriority: 10,
          render(data, type) {
            return self.getWorkflowName(data.workflowId);
          }
        },
        {
          data: null,
          name: self.$t('downTimes.table.reason'),
          // width: '10%',
          responsivePriority: 0,
          render(data, type) {
            if (data.reason) {
              return data.reason.join(' / ');
            }
            return '';
          }
        },
        {
          data: null,
          name: self.$t('downTimes.table.start'),
          responsivePriority: 10,
          render(data, type) {
            if (type === 'display' || type === 'filter') {
              return self.getFormattedDownTimeIndicator(data.id);
            } else {
              if (type === 'export') {
                return moment(data.downTimeIndicator).format('DD-MM-YY HH:mm:ss');
              }
              return moment(data.downTimeIndicator).unix();
            }
          }
        },
        {
          data: null,
          name: self.$t('downTimes.table.end'),
          responsivePriority: 10,
          render(data, type) {
            if (!data.downTimeEnded) {
              return 'Down';
            }
            const ended = data.downTimeEnded && data.downTimeEnded.toDate ? data.downTimeEnded.toDate() : data.downTimeEnded;
            if (type === 'display' || type === 'filter') {
              return moment(ended).format('DD-MM-YY HH:mm:ss');
            } else {
              if (type === 'export') {
                return moment(ended).format('DD-MM-YY HH:mm:ss');
              }
              return moment(ended).unix();
            }
          }
        },
        {
          data: null,
          name: self.$t('downTimes.table.timeSpentRunning'),
          width: '2%',
          responsivePriority: 10,
          render(data, type) {
            if (!data.downTimeEnded) {
              let diff = moment().diff(moment(data.downTimeIndicator));
              if (type === 'display' || type === 'filter' || type === 'export') {
                let converted = self.convertMs(diff);
                return `${converted.hrs}:${converted.min}:${converted.sec}`;
              }
              return diff;
            }
            if (type === 'display' || type === 'filter' || type === 'export') {
              return data.timeSpentRunning;
            }
            return data.timeSpentRunningSort;
          }
        },
        {
          data: null,
          name:  self.$t('downTimes.table.jobDownTimePercentage'),
          width: '1%',
          responsivePriority: 10,
          render(data, type) {
            let timeSpent = data.downTimeEnded
              ? data.timeSpentRunningSort
              : moment().diff(moment(data.downTimeIndicator));
            const total = self.job.calculatedTimeSpent;
            let percentage = total ? _.round(timeSpent / total * 100, 2) : 0;
            if (type === 'display' || type === 'filter' || type === 'export') {
              return percentage.toFixed(2) + ' %';
            }
            return percentage;
          }
        },
        // {
        //   data: null,
        //   name: self.$t('downTimes.table.user'),
        //   width: '10%',
        //   responsivePriority: 10,
        //   render(data, type) {
        //     return data.userName;
        //   }
        // },
        {
          data: null,
          name: self.$t('downTimes.table.userDeclaredBy'),
          width: '10%',
          responsivePriority: 10,
          render(data, type) {
            return data.declaredDownTimeBy ? data.declaredDownTimeBy : '';
          }
        },
        {
          data: null,
          name: this.$root.$t('ui.options'),
          searchable: false,
          orderable: false,
          width: '1%',
          responsivePriority: 0,
          render(data) {
            return '<a data-to="/downtimes/' + data.id + '" class="action-icon dt-router-link"><i title="View" class="far fa-eye"></i></a>';
          }
        }
      ];
      return statusAndButtonColumns;
    }
  },
  watch: {
    'job.id': {
      immediate: true,
      handler(newId) {
        this.jobId = newId;
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.channelOpen) {
      await this.$store.dispatch('downTimes/closeDBChannel');
      this.channelOpen = false;
    }
    let where = [
      ['companyId', '==', this.getClaims.companyId],
      ['downTimeRunning', '==', true]
    ];
    await this.$store.dispatch('downTimes/openDBChannel', {where}).catch(e => {
      console.error(e);
    });
    next();
  },
  async created() {
    const where = [
      ['companyId', '==', this.getClaims.companyId],
      ['jobId', '==', this.job.id]
    ];
    await this.$store.dispatch('downTimes/closeDBChannel', {clearModule: true}).catch(() => {});
    this.$store.dispatch('downTimes/openDBChannel', {where}).then(() => {
      this.channelOpen = true;
    }).catch(e => {
      console.error(e);
    });
    this.tableInitOptions.order = [[3, 'desc']];
    this.tableInitOptions.bStateSave = false;
    this._tickInterval = setInterval(() => { this.drawTick++; }, 1000);
  },
  beforeDestroy() {
    clearInterval(this._tickInterval);
  }
};
</script>
